import { useMutation } from "@tanstack/react-query";
import { journalsServiceApi } from "@/entities/api";

type BuildSignLineParams = {
  sectionFourListId: string;
  itemNoVersionId: string;
  signerEmployeeId: string;
  itemPartOneId: string;
};

const buildSignLinePartOne = async (params: BuildSignLineParams) => {
  const {
    sectionFourListId,
    itemNoVersionId,
    signerEmployeeId,
    itemPartOneId,
  } = params;

  const token = localStorage.getItem("token");

  const response = await journalsServiceApi.post(
    `journals/section-four/${sectionFourListId}/items/${itemNoVersionId}/itemPartOne/${itemPartOneId}/sign`,
    { signerEmployeeId },
    {
      responseType: "text",
      headers: {
        "X-Auth": token || "",
      },
    },
  );

  return response.data;
};

export const useBuildSignLinePartOne = () => {
  return useMutation<string, Error, BuildSignLineParams>({
    mutationFn: buildSignLinePartOne,
  });
};
